<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-button v-if="can('create', 'employees')" variant="success" @click="newEmployee">Alta de colaborador</b-button>
        <hr>
        <resource-filter @input="getAndShowEmployee($event.id)" without trashed class="mb-5"></resource-filter>
      </b-col>
      <b-col cols="9">
        <employee-manager class="mt-2 mb-5" v-if="available"></employee-manager>
        <div v-else>
          <div class="row justify-content-center">
            <div class="col-md-4">
              <div>
                <img src="svg/undraw_add_file2_gvbb.svg" class="img-fluid" alt="icon">
              </div>
              <div class="text-muted text-center">
                Selecciona o agrega algún empleado
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col></b-col>
      <b-col cols="9">
        <b-button variant="success" @click="storeIfValid" v-if="state=='creating'" size="lg">Guardar nuevo empleado</b-button>
        <b-button variant="success" @click="updateIfValid" v-if="state=='updating'" size="lg">Actualizar datos de empleado</b-button>
      </b-col>
    </b-row>
    <b-modal ok-only @change="updateShowError" ref="errorModal" title="Error" header-bg-variant="danger" header-text-variant="light" ok-variant="light">
      <ul>
        <li v-for="(errorMessage, index) in errorMessages" :key="index">{{errorMessage}}</li>
      </ul>
    </b-modal>
  </b-container>

</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { Validation, can } from '../utils';

import ResourceFilter from '../employees/ResourceFilter.vue';
import EmployeeManager from '../employees/EmployeeManager.vue';

export default {
  components: {
    ResourceFilter,
    EmployeeManager
  },
  computed: mapState({
    available: state=>state.employeeManager.available,
    showError: 'showError',
    errorMessages: 'errorMessages',
    state: state=>state.employeeManager.state,
    department_id: state=>state.employeeManager.employee.department_id,
    names: state=>state.employeeManager.employee.names,
    first_surname: state=>state.employeeManager.employee.first_surname,
    second_surname: state => state.employeeManager.employee.second_surname,
    alias: state=>state.employeeManager.employee.alias,
    start_working_date: state=>state.employeeManager.employee.start_working_date,
    birthday: state=>state.employeeManager.employee.birthday,
    currency: state=>state.employeeManager.employee.currency,
    sales_man: state=>state.employeeManager.employee.sales_man,
    canceling_fund_limit: state=>state.employeeManager.employee.canceling_fund_limit,
    currencies: state=>state.employeeManager.currencies,
    salaries: state => _.flatMap(state.employeeManager.employee.payrollConfigs, pc => pc.salaries),
    employments: state=>state.employeeManager.employee.employments,
    commissionLevels: state=>state.employeeManager.employee.commissionLevels,
    isEmployeeCopy: state => state.employeeManager.employee.original_employee_id !== null,
    canExcludeEmptyJobTitles: () => !can('view', 'job_titles'),
    canExcludeEmptySalaries: () => !can('view', 'salaries') || !can('view', 'manager_salaries_report'),
    employeeStatus: state => state.employeeManager.employee.employeeStatus,
  }),
  methods: {
    ...mapActions(['newEmployee', 'saveChanges', 'storeEmployeeAndUpdate','getAndShowEmployee']),
    ...mapMutations(['updateShowError']),
    can: can,
    storeIfValid(){
      var validation = this.valid();
      if(validation.valid)
        this.storeEmployeeAndUpdate();
      else
        this.$store.dispatch('displayError', validation.messageBag);
    },
    updateIfValid(){
      var validation = this.valid();
      if(validation.valid)
        this.saveChanges();
      else
        this.$store.dispatch('displayError', validation.messageBag);
    },
    valid(){
      var validator = new Validation();
      validator.rule(
        this.names.length>=2, 'El nombre debe tener al menos 2 letras');
      validator.rule(
        this.start_working_date!='', 'Debe haber una fecha en la que inició a trabajar');
      validator.rule(
        this.birthday!='', 'Debe haber fecha de nacimiento');
      validator.rule(
        this.currencies.indexOf(this.currency)!=-1, 'Moneda inválida');
      /* validator.rule(
        this.salaries.length>0 || this.isEmployeeCopy || this.canExcludeEmptySalaries, 'El empleado debe tener al menos 1 salario registrado'); */
      validator.rule(
        this.employments.length>0 || this.isEmployeeCopy || this.canExcludeEmptyJobTitles, 'El empleado debe tener un puesto dado de alta');

      return validator.validate();
    }
  },
  mounted: ()=>{
    store.dispatch('resourceFilter/searchAndUpdate');
    store.commit('initialEnterprises', enterprises);
    store.commit('initialPayers', payers);
    store.commit('initialStatus', estado  );
    store.commit('initialCommissionRulesGroups', commissionRulesGroups);
    store.commit('initialQsPaymentRulesGroups', qsPaymentRulesGroups);
    store.commit('initialCommissionLevels', commissionLevels);
    store.commit('initialcommissionLevelRoles', commissionLevelRoles);
    store.commit('initialCancellingFundTypes', cancellingFundTypes);
    store.commit('initialBusinessNames', businessNames);
    store.commit('initialKardex', kardex);
    store.commit('initialQuizzes', quizzes);
    store.commit('initialSchedules', schedules);
  },
  watch: {
    showError(v) {
      if(v==true)this.$refs.errorModal.show();
      else this.$refs.errorModal.hide()
    }
  }
}
</script>
